import {
  DEFAULT_COLOR_THEME,
  DEFAULT_DENSITY,
  TColorTheme,
  TColorThemeBrand,
  TDensity,
  getColorThemeBrand,
  getFrameColorTheme,
} from '@qmulus/ui/utils/appearance.ts';
import {
  computed,
  shallowRef,
} from 'vue';

import {
  refreshChartTheme,
} from '@/utils/chart-theme.ts';

// Shared by every caller, so the selection survives leaving the settings page. It is not stored
// yet, so reloading the page returns to the defaults.
const selectedColorTheme = shallowRef<TColorTheme>(DEFAULT_COLOR_THEME);
const selectedDensity = shallowRef<TDensity>(DEFAULT_DENSITY);

/** The color theme and density of the whole app, applied to the root element as soon as they change. */
export function useAppearance() {
  const colorTheme = computed<TColorTheme>({
    get: () => selectedColorTheme.value,
    set: (newColorTheme) => {
      selectedColorTheme.value = newColorTheme;
      document.documentElement.dataset.theme = newColorTheme;
      void refreshChartTheme();
    },
  });

  const density = computed<TDensity>({
    get: () => selectedDensity.value,
    set: (newDensity) => {
      selectedDensity.value = newDensity;
      document.documentElement.dataset.density = newDensity;
    },
  });

  const colorThemeBrand = computed<TColorThemeBrand>(() => getColorThemeBrand(selectedColorTheme.value));
  const frameColorTheme = computed(() => getFrameColorTheme(selectedColorTheme.value));

  return {
    colorTheme,
    colorThemeBrand,
    density,
    frameColorTheme,
  };
}
